import { useState, useEffect, useCallback } from "react";
import apiAgent from "../api/apiAgent";

export const useRequirementFilter = (initialState) => {
  const [requirementInfo, setRequirementInfo] = useState(initialState || {});

  useEffect(() => {
    setRequirementInfo(initialState || {});
  }, [initialState]);

  const [dropdownData, setDropdownData] = useState({
    propertyTypeDD: [],
    saleTypeDD: [],
    floorSizeUnitsDD: [],
    erfSizeUnitsDD: [],
  });

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchFilterData = async () => {
      try {
        const response = await apiAgent.Contact.ContactRequirementFilterData();
        const { propertyTypes, saleType, floorSizeUnits, erfSizeUnits } =
          response;

        let formattedPropertyTypes = [];
        if (propertyTypes) {
          for (const group of propertyTypes) {
            formattedPropertyTypes.push({
              label: group.classification,
              values:
                group.types?.map((item) => ({
                  label: item,
                  value: `${group.classification}-${item}`,
                })) || [],
            });
          }
        }

        setDropdownData({
          propertyTypeDD: formattedPropertyTypes,
          saleTypeDD: saleType || [],
          floorSizeUnitsDD: floorSizeUnits || [],
          erfSizeUnitsDD: erfSizeUnits || [],
        });
      } catch (error) {
        console.error("Failed to fetch requirement filter data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchFilterData();
  }, []);

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setRequirementInfo((prev) => ({ ...prev, [name]: value }));
  }, []);

  const handleNumericChange = useCallback((id, value) => {
    setRequirementInfo((prev) => ({ ...prev, [id]: value }));
  }, []);

  const onPropertyTypesChange = useCallback((options) => {
    setRequirementInfo((prev) => ({ ...prev, PropertyTypes: options }));
  }, []);

  const areaSelectionChanged = useCallback((e) => {
    const selectedArea = e.suburb === "" ? e.town : `${e.town}, ${e.suburb}`;
    setRequirementInfo((prev) => ({
      ...prev,
      Areas: [...(prev.Areas || []), selectedArea],
    }));
  }, []);

  const areaSelectionRemoved = useCallback((areaToRemove) => {
    setRequirementInfo((prev) => ({
      ...prev,
      Areas: prev.Areas.filter((area) => area !== areaToRemove),
    }));
  }, []);

  const handleUnitChange = useCallback((field, value) => {
    setRequirementInfo((prev) => ({ ...prev, [field]: value }));
  }, []);

  const resetRequirementInfo = useCallback(() => {
    setRequirementInfo({
      SaleType: "",
      PropertyTypes: [],
      FloorSize: 0,
      FloorSizeUnits: "1",
      ErfSize: 0,
      ErfSizeUnits: "1",
      BedRooms: 0,
      Bathrooms: 0,
      Garages: 0,
      Parkings: 0,
      PriceFrom: 0,
      PriceTo: 0,
      Areas: [],
    });
  }, []);

  return {
    requirementInfo,
    dropdownData,
    isLoading,
    handlers: {
      handleChange,
      handleNumericChange,
      onPropertyTypesChange,
      areaSelectionChanged,
      areaSelectionRemoved,
      handleUnitChange,
      resetRequirementInfo,
    },
  };
};
